const getSvgWidth = (svgSize: string) => {
  let avatarWidth;
  switch (svgSize) {
    case 'small':
      avatarWidth = 23;
      break;
    case 'large':
      avatarWidth = 46;
      break;
    case 'xlarge':
      avatarWidth = 55;
      break;
    default:
      avatarWidth = 37;
      break;
  }
  return avatarWidth;
};
const getSvgHeight = (svgSize: string) => {
  let avatarHeight;
  switch (svgSize) {
    case 'small':
      avatarHeight = 20;
      break;
    case 'large':
      avatarHeight = 40;
      break;
    case 'xlarge':
      avatarHeight = 48;
      break;
    default:
      avatarHeight = 32;
      break;
  }
  return avatarHeight;
};
export { getSvgWidth, getSvgHeight };
